import { SageV4App } from "./pages/SageV4App";

export function App() {
  return <SageV4App />;
}
